<template>
    <v-container fluid>
        <v-main>
            <v-card flat>
                <v-tabs
                    v-model="tabs"
                    right
                    @change="tabChanged"
                >
                    <v-tab>Dashboard</v-tab>
                    <v-tab key="dashboard">Articles</v-tab>
                    <v-tab key="personalities">Personalities</v-tab>
                    <v-tab key="categories">Categories</v-tab>
                    <v-tab key="carousel">Carousel</v-tab>
                    <v-tab key="settings">Settings</v-tab>
                </v-tabs>
                <v-tabs-items
                    v-model="tabs"
                >
                    <v-tab-item>
                        <v-card>
                            <v-card-text>dashboard comes here soon....</v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card>
                            <v-card-text>
                                <tab_articles></tab_articles>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card>
                            <v-card-text>
                                <tab_personalities></tab_personalities>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card>
                            <v-card-text>categories comes here soon....</v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card>
                            <v-card-text>
                                <tab_carousel
                                    :remove="true"
                                ></tab_carousel>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card>
                            <v-card-text>Magazin settings comes here soon...</v-card-text>
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
            </v-card>
        </v-main>
    </v-container>
</template>

<script>

import tab_articles from './_components/articles/articles'
import tab_carousel from './_components/carousel/items'
import tab_personalities from './_components/personalities/table'

export default {
    name: "Magazine",

    components: {
        tab_articles,
        tab_carousel,
        tab_personalities
    },

    data() {
        return ({
            tabs: 1,
            article: {},
            openArticle: false,
            list: [],
            loading: true,
            disabled: false,
            search: '',
        })
    },

    watch: {
        tabs(tab) {
            //alert(tab)
        }
    },

    mounted() {},

    computed: {},

    methods: {

        tabChanged: function(tab) {
            //alert(tab);
        }
    },

};
</script>
